/**
 * 検査項目
 */
export class Inspection {
    /** 検査項目コード */
    code = ""
    /** 検査項目名 */
    name = ""
    /** 検査項目名（略称） */
    shortName = ""
    /** 検査分類コード */
    classificationCode = ""
    /** その他項目フラグ 0: 検査項目 1: その他の項目 ※報告書が不要かどうかの判断 */
    otherItem = false
    /** 検査日数 */
    days = 0
    /** 標準単価 */
    standardPrice = 0

    /**
     * コンストラクタ
     * @param init 
     */
    constructor(init?: Partial<Inspection>) {
        Object.assign(this, init)
    }

    /**
     * 複製を作成する
     */
    clone() {
        return new Inspection(JSON.parse(JSON.stringify(this)));
    }

}
